import headers from "app/requests/headers";

export const create = (params) => (
  fetch("/api/admin/organizations", {
    body: JSON.stringify({organization: params}),
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);

export const destroy = (id) => (
  fetch(`/api/admin/organizations/${id}`, {
    headers: headers(),
    method: "DELETE"
  }).then((response) => response.json())
);

export const get = (id) => (
  fetch(`/api/admin/organizations/${id}`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);

export const list = () => (
  fetch("/api/admin/organizations", {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);

export const update = (id, params) => (
  fetch(`/api/admin/organizations/${id}`, {
    body: JSON.stringify({organization: params}),
    headers: headers(),
    method: "PUT"
  }).then((response) => response.json())
);
